export enum ChatMemberStatus
{
  Active = 0,
  Blocked = 1,
  Left = 2,
}
